/* global window */
/* eslint no-alert: 0 */
/* eslint no-console: 0 */

export default {
  alert(message) {
    window.alert(message);
  },
  log(...args) {
    console.error(args);
  },
};



// WEBPACK FOOTER //
// ./src/lib/error.js